export default __webpack_public_path__ + "static/media/terms_pt-BR.80de1287.pdf";